export enum ESGInvestmentType {
  ENVIRONMENTAL = 'ENVIRONMENTAL',
  SOCIAL = 'SOCIAL',
  GOVERNANCE = 'GOVERNANCE',
}

export enum NonESGInvestmentType {
  BIODIVERSITY = 'BIODIVERSITY',
  HUMAN_RIGHTS = 'HUMAN_RIGHTS',
  WATER = 'WATER',
  ANTI_CORRUPTION_FIGHT = 'ANTI_CORRUPTION_FIGHT',
  SOCIAL = 'SOCIAL',
  ENVIRONMENT = 'ENVIRONMENT',
  ENERGETIC_PERFORMANCE = 'ENERGETIC_PERFORMANCE',
  WASTE_TREATMENT = 'WASTE_TREATMENT',
}

export enum ESGInvestmentForbiddenType {
  NUCLEAR = 'NUCLEAR',
  ARMAMENT = 'ARMAMENT',
  TOBACCOS = 'TOBACCOS',
  ALCOOL = 'ALCOOL',
  CHARBON_THERMIQUE = 'CHARBON_THERMIQUE',
  DIVERTISSEMENTS_POUR_ADULTES = 'DIVERTISSEMENTS_POUR_ADULTES',
  ENERGIES_FOSSILES = 'ENERGIES_FOSSILES',
  HUILE_DE_PALME = 'HUILE_DE_PALME',
  JEUX_DE_HASARD = 'JEUX_DE_HASARD',
  PESTICIDES = 'PESTICIDES',
  RECHERCHE_SUR_LES_EMBRYONS_HUMAINS = 'RECHERCHE_SUR_LES_EMBRYONS_HUMAINS',
  OPIOIDES = 'OPIOIDES',
  PRISONS_PRIVEES = 'PRISONS_PRIVEES',
  PRODUCTION_OU_EXTRACTION_DE_MATERIELS_RADIOTACTIFS = 'PRODUCTION_OU_EXTRACTION_DE_MATERIELS_RADIOTACTIFS',
  TRAFICS_ESPECES_ANIMALES_MENACEES = 'TRAFICS_ESPECES_ANIMALES_MENACEES',
}

export interface OwnerEsgProfile {
  id?: number;
  ownerId: number;
  score?: number;
  includeESG: boolean;
  taxonomy?: number;
  sustainability?: number;
  investments?: ESGInvestmentType[];
  includeNonESG?: boolean;
  nonESGInvestments?: NonESGInvestmentType[];
  investmentsForbiden?: ESGInvestmentForbiddenType[];
  acceptRecommendations?: boolean;
}

export interface EsgFormData {
  includeESG: boolean;
  taxonomy: string;
  sustainability: string;
  investments: string[];
  includeNonESG: boolean;
  nonESGInvestments: string[];
  investmentsForbiden: string[];
  acceptRecommendations: boolean;
}

export const TAXONOMY_OPTIONS = [
  { id: '0', label: '0 %' },
  { id: '25', label: '25 %' },
  { id: '50', label: '50 %' },
  { id: '75', label: '75 %' },
  { id: '100', label: '100 %' },
];

export const SUSTAINABILITY_OPTIONS = [
  { id: '0', label: '0 %' },
  { id: '25', label: '25 %' },
  { id: '50', label: '50 %' },
  { id: '75', label: '75 %' },
  { id: '100', label: '100 %' },
];

export const INVESTMENT_OPTIONS = [
  { id: 'null', label: 'Aucun' },
  { id: 'ENVIRONMENTAL', label: 'Environnemental' },
  { id: 'SOCIAL', label: 'Social' },
  { id: 'GOVERNANCE', label: 'Gouvernance' },
];

export const NON_ESG_INVESTMENT_OPTIONS = [
  { id: 'null', label: 'Aucun' },
  { id: 'BIODIVERSITY', label: 'La biodiversité' },
  { id: 'HUMAN_RIGHTS', label: "Le respect des droits de l'homme" },
  { id: 'WATER', label: "L'eau" },
  { id: 'ANTI_CORRUPTION_FIGHT', label: 'La lutte anti-corruption' },
  { id: 'SOCIAL', label: 'Le social' },
  { id: 'ENVIRONMENT', label: "L'environnement" },
  { id: 'ENERGETIC_PERFORMANCE', label: 'La performance énergétique' },
  { id: 'WASTE_TREATMENT', label: 'Le traitement des déchets' },
];

export const FORBIDDEN_INVESTMENT_OPTIONS = [
  { id: 'null', label: 'Aucune' },
  { id: 'NUCLEAR', label: 'Nucléaire' },
  { id: 'ARMAMENT', label: 'Armement' },
  { id: 'TOBACCOS', label: 'Tabac' },
  { id: 'ALCOOL', label: 'Alcool' },
  { id: 'CHARBON_THERMIQUE', label: 'Charbon thermique' },
  { id: 'DIVERTISSEMENTS_POUR_ADULTES', label: 'Divertissements pour adultes' },
  { id: 'ENERGIES_FOSSILES', label: 'Energies fossiles' },
  { id: 'HUILE_DE_PALME', label: 'Huile de palme' },
  { id: 'JEUX_DE_HASARD', label: 'Jeux de hasard' },
  { id: 'PESTICIDES', label: 'Pesticides' },
  { id: 'RECHERCHE_SUR_LES_EMBRYONS_HUMAINS', label: 'Recherche sur les embryons humains' },
  { id: 'OPIOIDES', label: 'Opioïdes' },
  { id: 'PRISONS_PRIVEES', label: 'Prisons privées' },
  { id: 'PRODUCTION_OU_EXTRACTION_DE_MATERIELS_RADIOTACTIFS', label: 'Production ou extraction de matériels radioactifs' },
  { id: 'TRAFICS_ESPECES_ANIMALES_MENACEES', label: "Trafics d'espèces animales menacées" },
];
